import { render, staticRenderFns } from "./collectors.vue?vue&type=template&id=36bd0196&"
import script from "./collectors.vue?vue&type=script&lang=ts&"
export * from "./collectors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "collectors.vue"
export default component.exports